import { useEffect } from 'react'
import getGridColumnsProps from '../types/getGridColumnsProps'

interface useInitDevicesProps {
  getRows: Function
  getGridColumns: Function
  setRows: Function
  setDeleteEntryId: Function
  setShowModal: Function
  setShowOverlay: Function
  setColumns: Function
  setColumnWidths: Function
  setSorting: Function
  filter?: {} | null
}

const useInit = (props: useInitDevicesProps) => {
  useEffect(() => {
    //request server when the filter is on null (Filter component initializes the filter object)
    if (props.filter !== null) {
      const columnsRequest: Promise<getGridColumnsProps> = props
        .getGridColumns()
        .then((columnData: getGridColumnsProps) => {
          props.setColumnWidths([])
          props.setColumns(columnData.columns)
          props.setSorting(columnData.sorting)
          props.setColumnWidths(columnData.columnWidths)
        })

      const dataRequest: Promise<any> = props
        .getRows({
          setShowOverlay: props.setShowOverlay,
          setDeleteEntryId: props.setDeleteEntryId,
          setShowModal: props.setShowModal,
          filter: props.filter,
        })
        .then((data: any) => {
          props.setRows(data)
        })

      Promise.all([dataRequest, columnsRequest]).then(() => {
        props.setShowOverlay(false)
      })
    }
  }, [props.filter])
}

export default useInit
